import { _ } from "libs";

import React, { useContext } from "react";
import ReservationPageContext from "./reservationPageContext";
import { Form, Field } from "react-final-form";
import isEmail from "validator/lib/isEmail";
import isEmpty from "validator/lib/isEmpty";

const mustBeFilled = value => {
	if (value === undefined) {
		value = "";
	}
	return isEmpty(value, { ignore_whitespace: true }) ? _("validation.mustBeFilled") : undefined;
};
const required = value => (value ? undefined : _("validation.mustBeFilled"));
const canBeEmail = value => {
	if (typeof value === "string") {
		return !isEmail(value) ? _("validation.mustBeValidEmail") : undefined;
	}

	return undefined;
};

const EnterGuest = () => {
	const pageContext = useContext(ReservationPageContext);
	const { setPage, addPartnerToReservation, getReservationContext } = pageContext;

	return (
		<Form
			onSubmit={async ({ name, email }: { name: string; email?: string }) => {
				const user = {
					firstName: name,
					email: email,
				};
				addPartnerToReservation(user, "guest");
				getReservationContext({});
				setPage("summary");
			}}
			render={({ handleSubmit, pristine, invalid, form }) => (
				<form
					className="wizard enterGuestWizard"
					onSubmit={event => {
						handleSubmit(event).then(() => {
							form.reset();
						});
					}}
				>
					<div className="wizardHeader">
						<div
							className="back"
							onClick={() => {
								setPage("partner");
							}}
						/>
						<div className="title">{_("reservation.playerWithoutAccount.heading")}</div>
					</div>
					<div className="wizardBody">
						<div className="msg info">{_("reservation.playerWithoutAccountForm.info")}</div>
						<Field name="name" validate={mustBeFilled}>
							{({ input, meta }) => (
								<div className="field">
									<label>{_("reservation.playerWithoutAccountForm.name.label")}</label>
									<input type="text" {...input} />
									{meta.touched && meta.error && <p className="error">{meta.error}</p>}
								</div>
							)}
						</Field>
						<Field name="email" validate={canBeEmail}>
							{({ input, meta }) => (
								<div className="field">
									<label>{_("form.email.label")}</label>
									<input type="text" {...input} />
									{meta.touched && meta.error && <p className="error">{meta.error}</p>}
								</div>
							)}
						</Field>
					</div>
					<div className="wizardFooter">
						<button className="button fullWidth" type="submit" disabled={pristine || invalid}>
							{_("reservation.playerWithoutAccountForm.btnSubmit.label")}
						</button>
					</div>
				</form>
			)}
		/>
	);
};
export default EnterGuest;
